import update from 'immutability-helper';
import React, { useState } from 'react';
import { IOrderDetails } from '../../../models/product-detail';
import { IPatient } from '../../../models/prosites';
import { CartItemTypes, US } from '../../common/constants';
import SelectInput from '../../inputs/select-input';
import TextInput from '../../inputs/text-input';
import RadioSelect from './radio-select';
import { ProductOrderFormErrors } from './validation';
import { FormattedMessage, useIntl } from 'react-intl';
import { patientAges } from '../../common/constants';
import { canalTextures } from '../../common/constants';
import { previousVenting } from '../../common/constants';
import { ISession } from '../../../models/pro-sites';
import { isMiracleEar } from '../../../hooks/miracle-ear-hook';
interface IPatientSection {
    patientDetails: IPatient | undefined;
    updatePatientDetailsOnOrder: (patientDetails: IPatient) => void;
    isCustom: boolean;
    isPatientNumberRequired: boolean;
    orderDetails: IOrderDetails;
    errors: ProductOrderFormErrors;
    countryCode: string;
    session: ISession;
}

const PatientSection = ({
    patientDetails,
    updatePatientDetailsOnOrder,
    isCustom,
    isPatientNumberRequired,
    orderDetails,
    errors,
    countryCode,
    session,
}: IPatientSection) => {
    const [otherManufacturer, setOtherManufacturer] = useState<boolean>(false);
    const intl = useIntl();
    const reduceLastNameInputLength = session.country === US;

    const updatePatient = (event: any) => {
        switch (event.target.name) {
            case 'PatientFirstName':
                updatePatientDetailsOnOrder(
                    update(patientDetails!, {
                        firstName: { $set: event.target.value },
                    })
                );
                break;
            case 'PatientLastName':
                updatePatientDetailsOnOrder(
                    update(patientDetails!, {
                        lastName: { $set: event.target.value },
                    })
                );

                break;
            case 'PatientAge':
                updatePatientDetailsOnOrder(
                    update(patientDetails!, {
                        ageRange: { $set: event.target.value },
                    })
                );
                break;
            case 'PatientNumber':
                updatePatientDetailsOnOrder(
                    update(patientDetails!, {
                        agreementReference: {
                            $set: event.target.value,
                        },
                    })
                );
                break;
            case 'PatientCanalTexture':
                updatePatientDetailsOnOrder(
                    update(patientDetails!, {
                        canalTexture: { $set: event.target.value },
                    })
                );
                break;
            case 'isPreviousUser':
                updatePatientDetailsOnOrder(
                    update(patientDetails!, {
                        previousUser: {
                            $set:
                                event.target.value ===
                                intl.formatMessage({
                                    id: 'Yes',
                                    defaultMessage: 'Yes',
                                })
                                    ? true
                                    : false,
                        },
                        previousSerial: {
                            $set: '',
                        },
                        previousVenting: {
                            $set: 'None',
                        },
                        previousYearsOfUse: {
                            $set: '',
                        },
                    })
                );
                break;
            case 'otherManufacturerCheckBox':
                setOtherManufacturer(otherManufacturer ? false : true);
                if (!otherManufacturer) {
                    updatePatientDetailsOnOrder(
                        update(patientDetails!, {
                            previousSerial: {
                                $set: null,
                            },
                        })
                    );
                } else {
                    updatePatientDetailsOnOrder(
                        update(patientDetails!, {
                            otherManufacturerMakeModel: {
                                $set: null,
                            },
                        })
                    );
                }
                break;
            case 'PreviousSerial':
                if (!otherManufacturer) {
                    updatePatientDetailsOnOrder(
                        update(patientDetails!, {
                            previousSerial: {
                                $set: event.target.value,
                            },
                            otherManufacturerMakeModel: {
                                $set: null,
                            },
                        })
                    );
                } else {
                    updatePatientDetailsOnOrder(
                        update(patientDetails!, {
                            otherManufacturerMakeModel: {
                                $set: event.target.value,
                            },
                            previousSerial: {
                                $set: null,
                            },
                        })
                    );
                }
                break;
            case 'PreviousVenting':
                updatePatientDetailsOnOrder(
                    update(patientDetails!, {
                        previousVenting: {
                            $set: event.target.value,
                        },
                    })
                );
                break;
            case 'PreviousYearsOfUse':
                updatePatientDetailsOnOrder(
                    update(patientDetails!, {
                        previousYearsOfUse: {
                            $set: event.target.value,
                        },
                    })
                );
                break;
            default:
        }
    };

    return (
        <div>
            <div className="row row-m-b">
                <div className="col-md-12">
                    <h2 className="no-text-transform">
                        <FormattedMessage
                            id="Who_is_it_for"
                            defaultMessage="Who is it for?"
                        />
                    </h2>
                </div>
            </div>
            {!isMiracleEar(session.siteNumber) && (
                <div className="row row-m-b">
                    <div className="col-md-12">
                        <TextInput
                            placeholder={intl.formatMessage({
                                id: 'Enter_patients_first_name',
                                defaultMessage: "Enter patient's first name",
                            })}
                            name="PatientFirstName"
                            label={'Patients First Name'}
                            value={
                                patientDetails!.firstName
                                    ? patientDetails!.firstName!
                                    : ''
                            }
                            required={
                                isCustom || orderDetails.orderType === 'patient'
                            }
                            onChange={updatePatient}
                            labelClassName="col-sm-12 no-text-transform"
                            fieldClassName="col-sm-4"
                            customLabel={true}
                            maxLength={15}
                            error={errors.firstName}
                        />
                    </div>
                </div>
            )}
            <div className="row row-m-b">
                <div className="col-md-12">
                    <TextInput
                        placeholder={
                            isMiracleEar(session.siteNumber)
                                ? intl.formatMessage({
                                      id: 'Enter_patient_reference',
                                      defaultMessage: 'Enter patient reference',
                                  })
                                : intl.formatMessage({
                                      id: 'Enter_patients_last_name',
                                      defaultMessage:
                                          "Enter patient's last name",
                                  })
                        }
                        name="PatientLastName"
                        label={
                            isMiracleEar(session.siteNumber)
                                ? 'Patient Reference #'
                                : 'Patients Last Name'
                        }
                        value={
                            patientDetails!.lastName
                                ? patientDetails!.lastName!
                                : ''
                        }
                        required={
                            isCustom || orderDetails.orderType === 'patient'
                        }
                        onChange={updatePatient}
                        labelClassName="col-sm-12 no-text-transform"
                        fieldClassName="col-sm-4"
                        customLabel={true}
                        maxLength={reduceLastNameInputLength ? 15 : 30}
                        error={errors.lastName}
                    />
                </div>
            </div>
            <div className="row row-m-b">
                <div className="col-md-12">
                    <div className="col-sm-3" style={{ padding: '0' }}>
                        <SelectInput
                            name="PatientAge"
                            label="Age Range"
                            value={patientDetails!.ageRange}
                            onChange={updatePatient}
                            options={patientAges.map((ageRange) => ({
                                value: ageRange.value,
                                text: intl.formatMessage({
                                    id: ageRange.text,
                                    defaultMessage: ageRange.text,
                                }),
                            }))}
                            required={
                                isCustom || orderDetails.orderType === 'patient'
                            }
                            hasDefaultOption={true}
                            defaultOption={intl.formatMessage({
                                id: 'Choose_age_range',
                                defaultMessage: 'Choose age range',
                            })}
                            labelClassName="col-sm-12"
                            fieldClassName="col-sm-12"
                            customLabel={true}
                            error={errors.ageRange}
                        />
                    </div>
                </div>
            </div>
            {!isMiracleEar(session.siteNumber) && (
                <div className="row row-m-b">
                    <div className="col-md-12">
                        <TextInput
                            placeholder={intl.formatMessage({
                                id: 'Enter_patients_number',
                                defaultMessage: "Enter patient's number",
                            })}
                            name="PatientNumber"
                            label={'Patient #'}
                            value={patientDetails!.agreementReference}
                            required={isPatientNumberRequired}
                            onChange={updatePatient}
                            labelClassName="col-sm-12 no-text-transform"
                            fieldClassName="col-sm-4"
                            maxLength={30}
                            customLabel={true}
                            error={errors.patientNumber}
                        />
                    </div>
                </div>
            )}
            {[
                CartItemTypes.CustomOnly,
                CartItemTypes.Earmold,
                CartItemTypes.BteWithEarmold,
                CartItemTypes.RicWithEarmold,
                CartItemTypes.RicWithAp,
                CartItemTypes.ApReceiver,
                CartItemTypes.SoundGearCustom,
                CartItemTypes.SoundGearEarmold,
            ].includes(orderDetails.cartItemTypeId!) && (
                <>
                    {' '}
                    {[
                        CartItemTypes.Earmold,
                        CartItemTypes.BteWithEarmold,
                        CartItemTypes.RicWithEarmold,
                        CartItemTypes.SoundGearEarmold,
                    ].includes(orderDetails.cartItemTypeId!) &&
                        countryCode !== 'FR' && (
                            <div className="row row-m-b">
                                <div className="col-md-12">
                                    <div
                                        className="col-sm-3"
                                        style={{ padding: '0' }}
                                    >
                                        <SelectInput
                                            name="PatientCanalTexture"
                                            label="Canal Texture"
                                            value={patientDetails!.canalTexture}
                                            onChange={updatePatient}
                                            options={canalTextures.map(
                                                (texture) => ({
                                                    value: texture.value,
                                                    text: intl.formatMessage({
                                                        id: texture.text,
                                                        defaultMessage:
                                                            texture.text,
                                                    }),
                                                })
                                            )}
                                            hasDefaultOption={true}
                                            defaultOption={
                                                intl.formatMessage({
                                                    id: 'Choose_Canal_Texture',
                                                    defaultMessage:
                                                        'Choose Canal Texture',
                                                }) + '...'
                                            }
                                            labelClassName="col-sm-12"
                                            fieldClassName="col-sm-12"
                                            customLabel={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    <div className="row row-m-b">
                        <div className="col-md-12">
                            <div className="col-md-12">
                                <h4>
                                    <FormattedMessage
                                        id={'Have_they_worn_aids'}
                                        defaultMessage={
                                            'Have they worn hearing aids before?'
                                        }
                                    />
                                </h4>
                            </div>
                            <div className="col-md-12">
                                <RadioSelect
                                    name="isPreviousUser"
                                    value={
                                        patientDetails!.previousUser
                                            ? intl.formatMessage({
                                                  id: 'Yes',
                                                  defaultMessage: 'Yes',
                                              })
                                            : intl.formatMessage({
                                                  id: 'No',
                                                  defaultMessage: 'No',
                                              })
                                    }
                                    options={[
                                        intl.formatMessage({
                                            id: 'Yes',
                                            defaultMessage: 'Yes',
                                        }),
                                        intl.formatMessage({
                                            id: 'No',
                                            defaultMessage: 'No',
                                        }),
                                    ]}
                                    onChange={updatePatient}
                                    isDisplayInline={true}
                                />
                            </div>
                        </div>

                        {patientDetails!.previousUser && (
                            <div>
                                <div
                                    className="col-sm-12"
                                    style={{ marginTop: '15px' }}
                                >
                                    <div className="col-sm-3">
                                        <TextInput
                                            name="PreviousSerial"
                                            label={
                                                otherManufacturer
                                                    ? 'Other Make/Model:'
                                                    : isMiracleEar(
                                                          session.siteNumber
                                                      )
                                                    ? 'Serial Number if Miracle Ear'
                                                    : 'Serial Number if Starkey'
                                            }
                                            value={
                                                patientDetails!
                                                    .previousSerial! ||
                                                patientDetails!
                                                    .otherManufacturerMakeModel!
                                            }
                                            onChange={updatePatient}
                                            labelClassName="col-sm-12"
                                            fieldClassName="col-sm-12"
                                            customLabel={true}
                                        />
                                        <input
                                            id="otherManufacturerCheckBox"
                                            name="otherManufacturerCheckBox"
                                            type="checkbox"
                                            checked={otherManufacturer}
                                            onChange={updatePatient}
                                            style={{
                                                marginLeft: '15px',
                                                marginRight: '2px',
                                            }}
                                        />
                                        <label
                                            htmlFor={
                                                'otherManufacturerCheckBox'
                                            }
                                        >
                                            <FormattedMessage
                                                id={'Other_Manufacturer'}
                                                defaultMessage={
                                                    'Other Manufacturer'
                                                }
                                            />
                                        </label>
                                    </div>
                                    <div className="col-sm-3">
                                        <SelectInput
                                            name="PreviousVenting"
                                            label="Venting"
                                            value={
                                                patientDetails!.previousVenting!
                                            }
                                            onChange={updatePatient}
                                            options={previousVenting.map(
                                                (venting) => ({
                                                    value: venting.value,
                                                    text: intl.formatMessage({
                                                        id: venting.text,
                                                        defaultMessage:
                                                            venting.text,
                                                    }),
                                                })
                                            )}
                                            labelClassName="col-sm-12"
                                            fieldClassName="col-sm-12"
                                            customLabel={true}
                                            hasDefaultOption={true}
                                            defaultOption={'Select'}
                                        />
                                    </div>
                                    <div className="col-sm-3">
                                        <TextInput
                                            name="PreviousYearsOfUse"
                                            label={'Years of Hearing Aid Use'}
                                            value={
                                                patientDetails!
                                                    .previousYearsOfUse!
                                            }
                                            onChange={updatePatient}
                                            labelClassName="col-sm-12"
                                            fieldClassName="col-sm-12"
                                            customLabel={true}
                                        />
                                    </div>
                                    <div className="col-sm-3" />
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default PatientSection;
